import React from "react";
import { Drawer, List, ListItemButton, ListItemText, Toolbar } from '@mui/material';
import Divider from '@mui/material/Divider';
import { Link, useLocation } from 'react-router-dom';

export default function SidebarMenu({ sciId }) {
  const location = useLocation();
  const sciPrefix = sciId ? `/scis/${sciId}` : '';

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: 200,
        flexShrink: 0,
        [`& .MuiDrawer-paper`]: { 
            width: 200,
            boxSizing: 'border-box',
            top: '72px',
            height: 'calc(100% - 64px)',
         }
      }}
    >
      <Toolbar />
      <List>
        <ListItemButton 
            component={Link} 
            to="/" 
            selected={location.pathname === '/'}
        >
          <ListItemText primary="Accueil" />
        </ListItemButton>
        <ListItemButton 
            component={Link} 
            to={`${sciPrefix}`}
            selected={location.pathname === `${sciPrefix}`}
        >
          <ListItemText primary="Informations SCI" />
        </ListItemButton>
        <ListItemButton 
            component={Link} 
            to="/locataires" 
            selected={location.pathname === '/locataires'}
        >
          <ListItemText primary="Recherche Locataire" />
        </ListItemButton>
        <ListItemButton 
            component={Link}
            to="/financier/info"
            selected={location.pathname === '/financier/info'}
        >
          <ListItemText primary="Informations financières" />
        </ListItemButton>
      </List>
      <Divider />
    </Drawer>
  );
}